import React from 'react';
import { useHover } from '../../context/HoverContext'; // Import the hook
import './StatusBar.css';

const StatusBar = () => {
  // Get the URL value directly from the context
  const { hoveredUrl } = useHover();

  if (!hoveredUrl) {
    return null;
  }

  return (
    <div className="custom-status-bar">
      {hoveredUrl}
    </div>
  );
};

export default StatusBar;